import PrerequisiteFailureSummary from "./PrerequisiteFailureSummary";

export default PrerequisiteFailureSummary;
export { PrerequisiteFailureSummary };
